import { useEffect, useState } from 'react';
import { useI18n } from '../lib/i18n';

/**
 * SUBIR AL TOPE — abajo a la derecha, en toda la app.
 *
 * Las pantallas del claim son largas de verdad (Claim Review tiene diez tarjetas), y el trabajo va
 * y vuelve entre el final y el principio: leés el contrato abajo y decidís arriba. Scrollear a
 * mano cada vez es la clase de fricción que nadie reporta como bug pero que cansa todo el día.
 *
 * Aparece recién a los 400px: un botón flotante sobre una pantalla que no scrollea es solo un
 * botón tapando contenido.
 *
 * Sube TAMBIÉN el contenedor scrolleable más cercano, no solo la ventana. Buena parte de la app
 * scrollea dentro de un panel (el drawer del claim, la lista del buzón) y ahí `window.scrollTo`
 * no hace absolutamente nada — el botón parecería roto.
 */
export function ScrollTopButton() {
  const { t } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => setVisible(window.scrollY > 400 || scrollablesArriba());
    check();
    window.addEventListener('scroll', check, { passive: true });
    // Los paneles internos scrollean sin emitir el scroll de la ventana: se escucha en captura.
    document.addEventListener('scroll', check, { passive: true, capture: true });
    return () => {
      window.removeEventListener('scroll', check);
      document.removeEventListener('scroll', check, { capture: true } as EventListenerOptions);
    };
  }, []);

  if (!visible) return null;
  return (
    <button
      onClick={subir}
      title={t('common.backToTop')}
      aria-label={t('common.backToTop')}
      style={{
        position: 'fixed', right: 18, bottom: 18, zIndex: 55,
        width: 38, height: 38, borderRadius: '50%', border: '1px solid var(--border)',
        background: 'var(--card)', color: 'var(--muted)', cursor: 'pointer',
        boxShadow: '0 2px 10px rgba(0,0,0,.18)', fontSize: 'var(--fs-md)', lineHeight: 1,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >↑</button>
  );
}

/** ¿Hay algún panel interno scrolleado hacia abajo? (el drawer, la lista del buzón, etc.) */
function scrollablesArriba(): boolean {
  return paneles().some((el) => el.scrollTop > 400);
}

function paneles(): HTMLElement[] {
  const out: HTMLElement[] = [];
  for (const el of document.querySelectorAll<HTMLElement>('div,main,section')) {
    if (el.scrollHeight - el.clientHeight > 200) {
      const ov = getComputedStyle(el).overflowY;
      if (ov === 'auto' || ov === 'scroll') out.push(el);
    }
  }
  return out;
}

function subir() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  for (const el of paneles()) if (el.scrollTop > 0) el.scrollTo({ top: 0, behavior: 'smooth' });
}
